import * as M from './messages';

export const tableBodyData_MM = [
  {
    leftCol: M.defined.small,
    middleCol: M.defined.smallRubberSize,
    rightCol: M.defined.smallLeatherSize,
  },
  {
    leftCol: M.defined.standard,
    middleCol: M.defined.standardRubberSize,
    rightCol: M.defined.standardLeatherSize,
  },
  {
    leftCol: M.defined.large,
    middleCol: null,
    rightCol: M.defined.largeLeatherSize,
  },
];

export const tableBodyData_INCH = [
  {
    leftCol: M.defined.small,
    middleCol: M.defined.smallRubberSizeInch,
    rightCol: M.defined.smallLeatherSizeInch,
  },
  {
    leftCol: M.defined.standard,
    middleCol: M.defined.standardRubberSizeInch,
    rightCol: M.defined.standardLeatherSizeInch,
  },
  {
    leftCol: M.defined.large,
    middleCol: null,
    rightCol: M.defined.largeLeatherSizeInch,
  },
];
